import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const TicketsQueueSelect = ({
	userQueues = [],
	selectedQueueIds = [],
	onChange,
}) => {
  const queues = Array.isArray(userQueues) ? userQueues : [];

	const handleChange = e => {
		const value = e.target.value;
		if (value[value.length - 1] === "all") {
			if (selectedQueueIds.length === queues.length) {
				onChange([]);
			} else {
				onChange(queues.map(q => q.id));
			}
		} else {
			onChange(value);
		}
	};

	return (
		<div style={{ width: 120, marginTop: -4 }}>
			<FormControl fullWidth margin="dense">
				<Select
					multiple
					displayEmpty
					variant="outlined"
					value={selectedQueueIds}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={() => i18n.t("ticketsQueueSelect.placeholder")}
				>
					<MenuItem dense value="all">
						<Checkbox
							indeterminate={selectedQueueIds.length > 0 && selectedQueueIds.length < queues.length}
							size="small"
							color="primary"
							checked={queues.length > 0 && selectedQueueIds.length === queues.length}
						/>
						<ListItemText primary={i18n.t("ticketsQueueSelect.all")} />
					</MenuItem>
					{queues.length > 0 &&
						queues.map(queue => (
							<MenuItem dense key={queue.id} value={queue.id}>
								<Checkbox
									style={{
										color: queue.color,
									}}
									size="small"
									color="primary"
									checked={selectedQueueIds.indexOf(queue.id) > -1}
								/>
								<ListItemText primary={queue.name} />
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsQueueSelect;
